import { render, staticRenderFns } from "./SecondaryNavMenu.vue?vue&type=template&id=20a901dc&scoped=true&"
import script from "./SecondaryNavMenu.vue?vue&type=script&lang=js&"
export * from "./SecondaryNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryNavMenu.vue?vue&type=style&index=0&id=20a901dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a901dc",
  null
  
)

export default component.exports